// /components/ui/breadcrumb.tsx
import React from 'react';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  href: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav className="text-sm text-neutral-600" aria-label="breadcrumb">
      <ol className="flex flex-wrap items-center space-x-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center">
              {index !== 0 && <span className="mx-1 text-neutral-400">›</span>}
              {isLast ? (
                <span className="font-semibold text-pink-600">{item.name}</span>
              ) : (
                <Link to={item.href} className="hover:underline hover:text-primary transition-colors">
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}